export class RAhrefs {
  static _hasConsent = false;

  static startTracking(ahrefsAnalyticsKey) {
    RAhrefs._attachScript(ahrefsAnalyticsKey);
  }

  static _attachScript(ahrefsAnalyticsKey) {
    // Create script element
    let scriptElement = document.createElement('script');
    scriptElement.async = true;
    scriptElement.src = 'https://analytics.ahrefs.com/analytics.js';
    scriptElement.setAttribute('data-key', ahrefsAnalyticsKey);

    // Attach script to dom before first script
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(scriptElement, firstScript);
  }
}
